<template>
  <div class="l-main c-bulk-data">
    <div class="c-bulk-data__nav">
      <app-tabs
        variant="pills"
        label="Bulk action"
        :tabs="bulkDataActionTabs"
        :value="selectedTab.key"
        @input="changeActiveTab"
      />
    </div>

    <component
      :is="selectedTab.component"
      v-if="languages.length"
      :key="selectedTab.key"
      :website="website"
      :languages="languages"
      :default-language-id="defaultLanguageId"
    />
    <div
      v-else
      class="c-bulk-data__loading"
    >
      <span class="ui-spinner" />
    </div>
  </div>
</template>

<script>
import ImportSeoRulesComponent from './bulk-actions/import'
import ExportSeoRulesComponent from './bulk-actions/export'
import { languageService } from '@/services/language'
import { jsonParse } from '@/helpers/transformers'
import get from 'lodash/get'
import AppTabs from '@/shared/app-tabs/AppTabs'

export default {
  name: "BulkDataComponent",

  components: {
    ImportSeoRulesComponent,
    ExportSeoRulesComponent,
    AppTabs,
  },

  props: {
    website: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      languages: [],
      defaultLanguageId: null,
      selectedTab: { label: 'Import', component: 'ImportSeoRulesComponent', key: 'import-seo-rules-component' },
      bulkDataActionTabs: [
        { label: 'Export', component: 'ExportSeoRulesComponent', key: 'export-seo-rules-component', icon: 'download' },
        { label: 'Import', component: 'ImportSeoRulesComponent', key: 'import-seo-rules-component', icon: 'upload' },
      ]
    };
  },

  created() {
    this.getAvailableLanguages();
  },

  methods: {
    changeActiveTab(key) {
      this.selectedTab = this.bulkDataActionTabs.find(tab => tab.key === key);
    },

    async getAvailableLanguages() {
      const allLanguagesResponse = await languageService.getAllOnlineLanguages();
      const allOnlineLanguages = allLanguagesResponse.data.items;

      const additionalLanguages = jsonParse(get(this, 'website.betshop.market.additionalLanguages')) || [];
      const defaultLanguage = get(this, 'website.betshop.market.defaultLanguage', 'en');

      const betshopLanguageCodes = [...new Set([defaultLanguage, ...additionalLanguages])];

      this.languages = allOnlineLanguages.filter(onlineLanguage => betshopLanguageCodes.includes(onlineLanguage.code))
      this.defaultLanguageId = this.languages.find(language => language.code === 'en')?.id
    },
  },
};
</script>

<style lang="scss" scoped>
.c-bulk-data {
  display: flex;
  flex-direction: column;
}

.c-bulk-data__nav {
  margin-bottom: 20px;
}

.c-bulk-data__loading {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}
</style>
